import { getAuthToken, removeAuthToken } from "../helper/token";
import { expiredTokenHandler } from "../../redux/slices/auth-slice";
import HttpError from "../helper/HttpError";

export const downloadDocument = async ( documentUrl
) => {
  try {
    const response = await  fetch(`${process.env.REACT_APP_API_URL}/api/user/download/${documentUrl}`,{
      method: "GET",
      headers :{
        "x-access-token": getAuthToken(),
      },
    })
    if (response.ok) {
      return response.blob();
    } else {
      const { message } = await response.json();
      if (response.status === 401) {
        removeAuthToken();
        // dispatch(expiredTokenHandler());
        throw new HttpError(401, message || "unauthorized user");
      } else {
        throw new HttpError(response.status, message || "something went wrong");
      }
    }
  } catch (error) {
    throw new HttpError(
      error?.status || 500,
      error?.message || "something went wrong"
    );
  }
};
